var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEFF1"
    },
    d: "M496,432.004H272c-8.832,0-16-7.136-16-16s0-311.168,0-320s7.168-16,16-16h224 c8.832,0,16,7.168,16,16v320C512,424.868,504.832,432.004,496,432.004z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M432,176.004H272c-8.832,0-16-7.136-16-16s7.168-16,16-16h160c8.832,0,16,7.168,16,16 S440.832,176.004,432,176.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M432,240.004H272c-8.832,0-16-7.136-16-16s7.168-16,16-16h160c8.832,0,16,7.168,16,16 S440.832,240.004,432,240.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M432,304.004H272c-8.832,0-16-7.136-16-16c0-8.864,7.168-16,16-16h160c8.832,0,16,7.168,16,16 S440.832,304.004,432,304.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M432,368.004H272c-8.832,0-16-7.136-16-16s7.168-16,16-16h160c8.832,0,16,7.168,16,16 S440.832,368.004,432,368.004z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1565C0"
    },
    d: "M282.208,19.716c-3.648-3.072-8.544-4.352-13.152-3.424l-256,48C5.504,65.7,0,72.324,0,80.004v352 c0,7.68,5.472,14.304,13.056,15.712l256,48c0.992,0.192,1.952,0.288,2.944,0.288c3.712,0,7.328-1.28,10.208-3.68 c3.68-3.04,5.792-7.552,5.792-12.32v-448C288,27.236,285.888,22.756,282.208,19.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M207.904,337.796c-0.832,7.328-6.592,13.184-13.92,14.08c-0.672,0.096-1.312,0.128-1.984,0.128 c-6.592,0-12.608-4.096-14.976-10.368L144,253.572l-33.024,88.064c-2.56,6.848-9.28,11.04-16.704,10.272 c-7.264-0.768-13.088-6.4-14.112-13.664l-16-112c-1.248-8.704,4.832-16.832,13.568-18.08c8.768-1.28,16.864,4.832,18.112,13.568 l7.136,50.048l26.016-69.408c4.672-12.48,25.28-12.48,29.984,0l24.512,65.344l8.608-77.504c0.992-8.768,9.12-15.072,17.664-14.144 c8.8,1.024,15.104,8.928,14.144,17.696L207.904,337.796z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/word_icon.d39c1c545193b0a24bb25c7d3f75105c.svg";
export { ForwardRef as ReactComponent };